<template>
  <span>
    <div class="content-wrap">
      <div class="sidebar" id="sidebar">
        <Headblock :leadin="lead" :registry="registry" :currentComponent="currentComponent" />
        <Progress :registry="registry" :lead="lead" />
        <footer id="footer1" class="d-tablet">
        <div class="container">
          <span v-if="!showEmail">
            <a v-if="country != 'Österreich'" href="tel:+49 511 93680377" class="tel-link"><span class="tel-link__icon icon-phone"></span><u>+49 511 93680377</u></a>
            <a v-if="country == 'Österreich'" href="tel:00800-71280-345" class="tel-link"><span class="tel-link__icon icon-phone"></span><u>00800-71280-345</u></a>
          </span>
          <div class="footer__txt">
            <p v-if="!showEmail">Sie haben noch offene Fragen? Wir sind für Sie da!</p>
            <!--<p v-if="showEmail">Sie haben noch offene Fragen? Schreiben Sie uns eine E-Mail an <a href="mailto:vertrag@agila.de" >vertrag@agila.de</a>.</p>-->
            <p v-if="lead.isUDSelling">Möchten Sie die Angaben zu Ihrem Tier oder Ihre persönlichen Daten ändern, nutzen sie unser <a href="/kontakt" target="_blank">Kontaktformular</a>.</p>

          </div>
          <ul class="footer__list">
            <li>
              <a href="https://www.agila.de/datenschutz" target="_blank"><u>Datenschutz</u></a>
            </li>
            <li>
              <a href="https://www.agila.de/impressum" target="_blank"><u>Impressum</u></a>
            </li>
          </ul>
          <div class="at_add" v-if="country == 'Österreich'"><br><br><br><br>
<br><br><br><br><br><br><br><br>            <p>Die Gesellschaft betreibt das Versicherungsgeschäft in Österreich im Rahmen des Dienstleistungsverkehrs.</p>
          </div>
        </div>
      </footer>
      </div>
      <main id="main">
        <div class="center" v-if="promiseResolved == false">
          <ActivityIndicator   />
        </div>
        <Pet :registry="registry" v-model="lead" ref="advancePet" v-if="currentComponent == 'Pet' && promiseResolved" v-on:leademit="lead = $event"/>
        <Person :registry="registry" v-model="lead" ref="advancePerson" v-if="currentComponent == 'Person'" v-on:leademit="lead = $event"/>
        <Health :registry="registry" v-model="lead" ref="advanceHealth" v-if="currentComponent == 'Health'" v-on:leademit="lead = $event"/>
        <Payment :registry="registry" v-model="lead" ref="advancePayment" v-if="currentComponent == 'Payment'" v-on:leademit="lead = $event"/>
      </main>
    </div>
    <footer id="footer">
        <div class="container">
         <!-- <span v-if="!showEmail">
            <a v-if="country != 'Österreich'" href="tel:+49 511 93680377" class="tel-link"><span class="tel-link__icon icon-phone"></span><u>+49 511 93680377</u></a>
            <a v-if="country == 'Österreich'" href="tel:00800-71280-345" class="tel-link"><span class="tel-link__icon icon-phone"></span><u>00800-71280-345</u></a>
          </span>-->

          <div class="footer__txt">
         <!--   <p v-if="!showEmail">Sie haben noch offene Fragen? Wir sind für Sie da!</p>-->
            <!--<p v-if="showEmail">Sie haben noch offene Fragen? Schreiben Sie uns eine E-Mail an <a href="mailto:vertrag@agila.de" >vertrag@agila.de</a>.</p>-->
          <!--  <p v-if="lead.isUDSelling">Möchten Sie die Angaben zu Ihrem Tier oder Ihre persönlichen Daten ändern, nutzen sie unser <a href="/kontakt" target="_blank">Kontaktformular</a>.</p>
          -->
          </div>
          <ul class="footer__list">
            <li>
              <a href="https://www.agila.de/datenschutz" target="_blank"><u>Datenschutz</u></a>
            </li>
            <li>
              <a href="https://www.agila.de/impressum" target="_blank"><u>Impressum</u></a>
            </li>
          </ul>
          <div class="at_add" v-if="country == 'Österreich'">
            <p>Die Gesellschaft betreibt das Versicherungsgeschäft in Österreich im Rahmen des Dienstleistungsverkehrs.</p>
          </div>
        </div>
      </footer>
    </span>
</template>
<script>
import Headblock from '../components/Header'
import Progress from '../components/Progress.vue'
import Pet from '../components/Pet.vue'
import Person from '../components/Person.vue'
import Payment from '../components/Payment.vue'
import ActivityIndicator from '../components/ActivityIndicator'
import Health from "@/components/Health.vue";

export default ({
  components: {
    Headblock,
    Progress,
    Pet,
    Health,
    Person,
    Payment,
    ActivityIndicator
  },
   model: {
        prop: 'lead',
        event: 'leademit'
    },
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        lead: {
            type: Object,
            default() {
                return {}
        }},
        current: {
            type: String,
            default() {
                return ''
        }},
        promiseResolved: {
          type: Boolean,
          default() {
            return false
          }
        }
    },
    data () {

      return {
        componentOrder: ['Pet', 'Person', 'Health', 'Payment'],

        componentsArray: {start: 'Pet', advancePet: 'Person', advancePerson: this.isHPS(this.lead) ? 'Payment' : 'Health', advanceHealth: 'Payment', advancePayment: 'Checkout'},
        hashComponentsArray: {start: 'tier', advancePet: 'persoenliche-daten', advancePerson: this.isHPS(this.lead) ? 'zahlung' : 'gesundheit', advanceHealth: 'zahlung', advancePayment: 'zusammenfassung'},
        hashComponentsCurArray: {'tier': 'Pet', 'persoenliche-daten': 'Person', 'gesundheit': 'Health', 'zahlung': 'Payment', 'zusammenfassung':'Checkout'},
        currentComponent: 'Pet',
        iconDone: '<i class="icon-check visible"></i>',
        showEmail: false,

      }
    },
    created() {
      // OP-change
      if (this.lead.productActive == 12 || this.lead.productActive == 11 || this.lead.productActive == 3) {
       // this.showEmail = true
      }
    },
    mounted() {


      window.onpopstate = () => {
        let comp = window.location.hash.split('#')[2]

        if (comp == undefined || comp == '') {
          this.currentComponent = 'Pet'
        }
        else {
          if (comp == 'zahlung') {
            this.lead.place = 3
          }
          this.currentComponent = this.hashComponentsCurArray[comp]

        }
        document.body.scrollTop = document.documentElement.scrollTop = 0;

     }
/*     window.scrollTo(0, 0)
        document.getElementById('jumppoint').scrollIntoView();
        window.scrollTo({top: 0})
        window.scroll({
   top: 0,
   left: 0,
   behavior: 'smooth'
});
document.documentElement.scrollTop = 0*/
      this.currentComponent = this.componentOrder[this.lead.place]

    },
    watch: {
        lead: {
            immediate: true,
            deep:true,
            handler (to) {
                this.race = to.race
                this.petbirthday = to.petbirthday
                this.petname = to.petname
                this.petgender = to.petgender
                this.petcolour = to.petcolour
                this.breed = to.breed
                this.health = (to.health !== undefined)? to.health: this.health;
                this.chronic = (to.chronic !== undefined)? to.chronic: this.chronic;
                this.respiratory = (to.respiratory !== undefined)? to.respiratory: this.respiratory;
                this.productInfo = to.productInfo
                this.productName = to.productName
                this.productPrice = to.productPrice
                this.breed = to.breed
                this.productSet = to.productSet
                this.productActive = to.productActive
                this.race = to.race
                this.firstname = to.firstname
                this.lastname = to.lastname
                this.petname = to.petname
                this.gender = to.gender
                this.birthday = to.birthday
                this.email = to.email
                this.phone = to.phone
                this.street = to.street
                this.number = to.number
                this.zip = to.zip
                this.city = to.city
                this.country = to.country
                this.paymentintervel = to.paymentinterval
                this.paymentType = to.paymentType
                this.firstPaymentDate = to.firstPaymentDate
                this.iban = to.iban
                this.sepa = to.sepa
                this.isLs = to.isLs
                this.place = to.place
                this.healthElements = to.healthElements
                this.symptomElements = to.symptomElements
            }
        },
        current: {
            immediate: true,
            handler (to) {
              if (to != '') {
                this.currentComponent = to
              }
            }
        }
    },

    methods: {
      back(place, where) {

        if (place == 0) {
          this.lead.productActive
          const urls = ['/versicherungen/tierkrankenschutz-tarife', '/versicherungen/op-kostenschutz-tarife', '/versicherungen/haftpflichtschutz-tarife']
          const productIDs = {'1': 0, '2': 0, '3': 1, '4': 0, '5': 2, '6': 2, '7': 2, '11': 1, '12': 1, '15': 2, '16': 2}

          window.location.href = urls[productIDs[this.lead.productActive]];
          return true;
        }

        this.lead.place = place
        history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#' + where)
        this.currentComponent = this.hashComponentsCurArray[where]
        document.getElementById('jumppoint').scrollIntoView();
      },
      advance(view, allow) {
        if (!allow) {
          return false;
        }

        this.lead[view] = true
        this.lead[view + 'Icon'] = this.iconDone

        if(view == 'advancePayment') {
          this.$parent.setPlace(4)
        }

        const saver = {'datetime': new Date(), 'data': this.lead}
        localStorage.setItem('leadData', JSON.stringify(saver));

        history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#' + this.hashComponentsArray[view])

        if(this.lead.jumpToEnd === true) {
          this.$parent.setPlace(4)
          history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#' + 'zusammenfassung')
        }


        this.currentComponent = this.componentsArray[view]

        document.getElementById('jumppoint').scrollIntoView();

        return true;
      }
    }

})
</script>


<style scoped>
.steps-list li .steps-list__info-item {
    display:none;
}
.steps-list__info-edit {
    display:none;
}
.show { display:block !important}
.center {
  margin: auto;
  width: 50%;
  padding: 10px;
  height:100%;
  text-align: center;
}
.center .web-loader {
  margin: 0;
  position: relative;
  top: 40%;
  left: 50%;

}
.at_add {
  position:relative;
  margin-top:15px;
}
</style>
